import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-tray",
  "use": "icon-th-tray-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-tray\">\n<path d=\"M26 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4ZM26 6V19H22.4125C22.15 18.9993 21.8899 19.0508 21.6474 19.1514C21.405 19.2521 21.1849 19.3999 21 19.5863L18.5863 22H13.4137L11 19.5863C10.815 19.3997 10.5947 19.2518 10.352 19.1512C10.1093 19.0506 9.84899 18.9992 9.58625 19H6V6H26ZM26 26H6V21H9.58625L12 23.4137C12.185 23.6003 12.4053 23.7482 12.648 23.8488C12.8907 23.9494 13.151 24.0008 13.4137 24H18.5863C18.849 24.0008 19.1093 23.9494 19.352 23.8488C19.5947 23.7482 19.815 23.6003 20 23.4137L22.4137 21H26V26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-tray.svg
// module id = NG6I
// module chunks = 83